<div class="analysis-options ac-modal dialog-width">
	<div class="header">
		<h3 class="text-align-center" dcrHTMLKey="SCENARIO_POPUP_TITLE">Change/Add Sample Scenarios</h3>
	</div>

	<div class="content larger" *ngIf="this.data; else noData">
		<div class="scenario-checkboxes grid">
			<div class="row">
				<div
					class="scenarios col-6 col-md-12 col-sm-24 col-padding-override"
					*ngFor="let hypotheticalCategory of hypotheticalScenarioCategories"
					[ngClass]="{
						hidden: !categorisedScenarios[hypotheticalCategory] || (categorisedScenarios[hypotheticalCategory] && !categorisedScenarios[hypotheticalCategory].length)
					}"
				>
					<sc-scenario-category
						[scenarios]="categorisedScenarios[hypotheticalCategory]"
						[category]="hypotheticalCategory"
						[selectedScenarios]="selectedScenarioKeys"
						[featuredScenarioStrings]="featuredScenarioStrings"
						[showInfoBubbles]="true"
						(onSelect)="selectScenario($event)"
						(onDeselect)="deselectScenario($event)"
					>
					</sc-scenario-category>
				</div>
			</div>
		</div>

		<div class="scenarios" [ngClass]="{ hidden: categorisedScenarios.past.length === 0 }">
			<div class="scenario-header">
				<img ada-decorative class="scenario-image" [src]="getImagePath('past')" onerror="this.style.visibility = 'hidden'" />
				<h4 dcrHTMLKey="PAST_MARKET_EVENTS_TITLE">PAST MARKET EVENTS</h4>
			</div>
		</div>

		<div class="scenario-checkboxes">
			<div class="scenarios wrap">
				<!-- AVOID USING METHOD CALLS, PLS REVIEW AND REMOVE THIS COMMENT/REFACTOR -->
				<sc-scenario
					*ngFor="let scenario of categorisedScenarios.past"
					[scenario]="scenario"
					[isSelected]="isSelected(scenario.rawValue)"
					[showInfoBubbles]="true"
					(onSelect)="selectScenario(scenario.rawValue)"
					(onDeselect)="deselectScenario(scenario.rawValue)"
				>
				</sc-scenario>
			</div>
		</div>
	</div>

	<ng-template #noData class="scenarios">
		<p class="text-align-center padding-20" dcrHTMLKey="NO_SCENARIO_RESULTS_TITLE">There are no scenarios to display</p>
	</ng-template>

	<div class="footer actions clearfix">
		<div class="button-actions d-flex">
			<button dz-button color="secondary" class="dialog-button" custom-tracking track-event="scenarios:scenario-selection-dialog:button:cancel" (click)="closeScenarios()">
				Cancel
			</button>
			<button dz-button class="dialog-button" (click)="saveScenarios()" [disabled]="!this.data || selectedScenarioKeys.length < 1" cdkFocusInitial>Save</button>
		</div>
	</div>
</div>
